export const config = {
  frontendUrl: process.env.REACT_APP_FRONTEND_URL,
  backendUrl: process.env.REACT_APP_BACKEND_URL,
};
